import globals from "@lvt/globals";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import applyCaseMiddleware from "axios-case-converter";

import { liveUnitsSearchValidator } from "@/api/liveUnits/liveUnitSchema";
import { LiveUnit } from "@/store/liveUnits/types";

import { validateRequest } from "../common";


const client = applyCaseMiddleware(
    axios.create({
        baseURL: globals.userdashboard.proxyUrl,
    }),
);

const fetchLiveUnitsThunk = (thunkName: string, url: string) =>
    createAsyncThunk(thunkName, async (_, { dispatch }) => {
        const request = client.get(url, {
            withCredentials: true,
        });

        const response = await validateRequest<Array<LiveUnit>>(
            dispatch,
            request,
            liveUnitsSearchValidator,
            "Failed to retrieve live units",
        );

        response.map((liveUnit) => {
            liveUnit.name = liveUnit.name.trim();
            liveUnit.serial = liveUnit.serial?.trim() ?? null;
        });

        return response;
    });

export const fetchLiveUnitsStream = fetchLiveUnitsThunk(
    "fetchLiveunits/legacy/stream",
    "/api/vms/legacy/live_units/search/stream",
);
export const fetchLiveUnitsArchives = fetchLiveUnitsThunk(
    "fetchLiveUnits/legacy/archives",
    "/api/vms/legacy/live_units/search/archives",
);
